const alphSort = (data, field) => {
	if (data instanceof Array) {
		return data.sort((a, b) => a?.[field]?.localeCompare(b?.[field]));
	}
	return data;
};

export default alphSort;
